module.exports = __webpack_public_path__ + "static/media/kanemite_15sc.c00259c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/aguacate/climasense/acaro_cafe_aguacate/kanemite_15sc.png
// module id = 1077
// module chunks = 3